import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useAuth } from "@/auth/AuthProvider";
import { Loader2 } from "lucide-react";

import { DefaultCatchBoundary } from "@/components/ui/catch-boundary";
import { DefaultPendingComponent } from "@/components/ui/pending-component";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) throw redirect({ to: "/login" });
  },
  component: AuthGate,
  errorComponent: DefaultCatchBoundary,
  pendingComponent: DefaultPendingComponent,
});

function AuthGate() {
  const { user, loading } = useAuth();

  if (loading || !user) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return <Outlet />;
}
